import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import { ActionButtonStyle } from '../../../utils/driveItem';
import { StoreState } from '../../../reducers';
import { DeleteButtonVariants } from './styles';
import { deleteItem, removeAllDownloads } from '../../DownloadManager/actions';
import UserAgentUtils from '../../../utils/userAgent';
const Translate = require('react-redux-i18n').Translate;

export interface DriveItemDeleteButtonProps {
	isDeletingAll: boolean;
	isDownloadingAll: boolean;
	driveItem?: Api.DriveItem;
	dispatch: Dispatch<StoreState>;
	style: ActionButtonStyle;
}

class DriveItemDeleteButton extends React.Component<DriveItemDeleteButtonProps, {}> {
	constructor(props: DriveItemDeleteButtonProps) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.renderButtonContent = this.renderButtonContent.bind(this);
	}

	handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		const { driveItem, style, dispatch, isDeletingAll } = this.props;

		e.stopPropagation();
		if (style !== ActionButtonStyle.ParametersPage && driveItem) {
			dispatch(deleteItem(driveItem));
		} else if (style === ActionButtonStyle.ParametersPage && !isDeletingAll) {
			dispatch(removeAllDownloads());
		}
	}

	renderButtonContent = () => {
		const { style, isDeletingAll } = this.props;

		const isPhone = UserAgentUtils.isPhone();

		if (style === ActionButtonStyle.Bar && !isPhone) {
			return <Translate value="messages.delete" />;
		} else if (style === ActionButtonStyle.Icon || (style === ActionButtonStyle.Bar && isPhone)) {
			return Utils.getSvgIcon('iconset_delete');
		} else if (style === ActionButtonStyle.ParametersPage) {
			return (
				<div>
					{isDeletingAll && Utils.getSvgIcon('iconset_loading')}
					<Translate value="messages.delete_data" />
				</div>
			);
		} else {
			return;
		}
	}

	render() {
		const { style, isDownloadingAll } = this.props;
		const DeleteButton = DeleteButtonVariants[style];
		const isDisabled = style === ActionButtonStyle.ParametersPage && isDownloadingAll;

		return (
			<DeleteButton onClick={this.handleClick} disabled={isDisabled}>
				{this.renderButtonContent()}
			</DeleteButton>
		);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { isDeletingAll, isDownloadingAll } = state.downloadManager;
	return { isDeletingAll, isDownloadingAll };
};

export default connect(mapStateToProps)(DriveItemDeleteButton);




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/DeleteButton/index.tsx